import { parseISO } from "date-fns";

export const parseDate = (date: string | Date): Date => {
  if (typeof date === "string") {
    const hasTimezone = Boolean(date.match(/(Z|[\+\-][\d:]*)$/));
    if (hasTimezone !== true) {
      date += "Z";
    }
    date = parseISO(date);
  }

  return date;
};
